import styled from "styled-components";
import * as G from "~/components/global.style";


export const ProductContainer = styled.div`
    display: block;
    margin:30px;


    /*display: grid;*/
    grid-template-areas: "head head" "content content";
    grid-template-columns: 1fr 1fr;

    > div:not([class]){
        grid-area: head;
        text-transform: uppercase;
        font-weight: bold;
        span{
            text-transform: initial;
            font-weight: initial;
        }
    }

    [role='tabpanel'] > div{
        //display: grid;
        @media(min-width: 1024px){
            display: grid;
            grid-template-areas: "head head" "content content";
            grid-template-columns: 1fr 1fr;
            grid-gap: 10px;
        }
    }

    .product__subtitle{
        font-size: 14px;
        color: ${G.PrimaryColor};
    }
    .status-New{
        i.ms-Button-icon{
            color: ${G.ColorUnAvailable}
        }
    }
    .status-Working{
        i.ms-Button-icon{
            color: ${G.ColorWaiting}
        }
    }
    .status-Ready{
        i.ms-Button-icon{
            color: ${G.ColorAvailable}
        }
    }
    .status-Discontinued{
        i.ms-Button-icon{
            color: ${G.ColorUnAvailable}
        }
    }

    &.vb-variant{
        > div[class^="vb-"]:nth-child(even){
            margin-left: 5px;
            width: calc(100% - 5px);    
        }
        > div[class^="vb-"]:nth-child(odd){
            margin-right: 5px;
            width: calc(100% - 5px);
        }
    }

    &.vb-product{
        > div[class^="vb-"]:nth-child(odd){
            margin-left: 5px;
            width: calc(100% - 5px);    
        }
        > div[class^="vb-"]:nth-child(even){
            margin-right: 5px;
            width: calc(100% - 5px);
        }
        .vb-text_dropdown,.vb-text_locale_dropdown{
            > div{
                display: inline-block;
            }
        }
        [role="menubar"]{
            .ms-Button-label{
                text-transform: capitalize;
            }
        }
    }

    .groupedFields{
        margin: 15px 0px;
        background: white;
        padding: 10px;
        > .groupedFields__content{
            display: flex;
            &.group-internaldimension, 
            &.group-internaldimensioncool,
            &.group-internaldimensionfreeze,
            &.group-externaldimension, 
            &.group-externaldimensioncool, 
            &.group-externaldimensionfreeze, 
            &.group-exteriordimension,  
            &.group-shelvesdimension,
            &.group-cartonsize,
            &.group-temperaturerange,
            &.group-temperaturerangecool,
            &.group-temperaturerangefreeze{
                > div{
                     > div{
                        > div{
                            label{
                                display: none;
                            } 
                        }
                    }    
                }    
            }

            &.group-temperaturerange,
            &.group-temperaturerangecool,
            &.group-temperaturerangefreeze{
                display: grid;
                grid-template-columns: 1fr 1fr;
            }
            > div{
                margin-top: 0;
                margin-bottom: 0;
                 > div{
                    > label{
                        font-size: 10px;
                    }                  
                }    
            }
            div:last-child > div > div > label{
                display: block;
            }

            &:last-child{

            }

            .vb-tags{
                input{
                    width: calc(100% - 10px) !important;
                    box-sizing: border-box;
                }
                .react-tags__selected button{
                    background: rgba(0,0,0,.04);
                }
            }
        }
    }
`;

export const FieldContainer = styled.div`
    width: 100%;
    margin: 15px 0px;
    clear: both;
    box-sizing: border-box;
    label{
 
        float: none;
        font-weight: bold;
    }
    .ms-Toggle{
        float: right;
        & + div{
            float: left;
        }
    }
    .ms-Checkbox{
      //  float: right;
    }
    .ms-TextField, .ms-Dropdown-container{
        clear: both;
    }

    .react-tags{
        label{
           
        }
        button{
            background: white;
            border: none;
            padding: 15px 25px;
            margin-right: 10px;
            margin-bottom: 10px;
        }

        .react-tags__selected{
            margin-bottom: 10px;
        }

        .react-tags__search{
            input{
                padding: 10px 20px;
            }
        }
        .react-tags__suggestions{
            background: white;
            width: 100px;
            padding: 0px 10px;
            ul{
                padding: 0;
                margin: 0;
                li{
                    padding: 10px;
                    list-style: none;
                    &:hover{
                        background: ${G.PrimaryColor};
                    }
                }
            }
        }
    }
    
    &.vb-text, &.vb-locale_text, &.vb-media, &.vb-locale_media {
        background: white;
        margin-bottom: 5px;
        padding: 10px;
    }
    
    &.vb-text_dropdown, &.vb-text_locale-dropdown{
        div > div{
           /* width: 50%;*/
        }
    }
`;


// WEBPACK FOOTER //
// ./src/components/product/product.style.ts